import React from 'react'
import Iframe from 'react-iframe'

const PublicDownloadView = ({publicDownloadList}) => {
    const url={publicDownloadList}
const downloadImage=(url) =>{
    fetch(url, {
      mode : 'no-cors',
    })
      .then(response => response.blob())
      .then(blob => {
      let blobUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.download = url.replace(/^.*[\\\/]/, '');
      a.href = blobUrl;
      document.body.appendChild(a);
      a.click();
      a.remove();
    })
  }
  return (
    <div
    className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
    id="exampleModalEdit"
    tabIndex={-1}
    aria-labelledby="exampleModalLabel"
    aria-modal="true"
    role="dialog"
  >
    <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
      <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
        <div className="flex justify-end">
          <svg
            data-bs-dismiss="modal"
            aria-label="Close"
            className="text-primary-blue h-8 w-8"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
            />
          </svg>
        </div>
        <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
        
       
      <div className=" w-full">
        <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
          View File
        </h1>
        <img className='mt-3' src={`${publicDownloadList.file}`} alt="" />


        <div className='text-primary-blue my-3 text-base'><label htmlFor="">File Name :</label> {`${publicDownloadList.title}`}</div>
     <div className='flex justify-center '>  <div onClick={()=>downloadImage(publicDownloadList.file)} className="rounded-2xl text-white bg-primary-red px-3 w-20 py-2">Download</div>
     </div>
      </div>
   
   
          
        </div>
        
      </div>
    </div>
  </div>
  )
}

export default PublicDownloadView